<!-- 标签管理 -->
<template>
  <div
    style="
      background-color: #f0f2f5;
      margin: -20px -30px -30px;
      padding: 20px 30px 30px;
      min-height: calc(100vh - 65px);
    "
  >
    <!-- 标题 -->
    <div style="background-color: #fff; padding: 20px; margin-bottom: 20px">
      <div class="page-title">公众号-标签管理</div>
      <div
        style="
          display: flex;
          align-items: center;
          flex-wrap: wrap;
          margin-top: 10px;
        "
      >
        <div class="screen-box">
          <div class="screen-label">渠道</div>
          <a-select
            show-search
            style="min-width: 200px"
            placeholder="请选择渠道"
            @change="handleChangeB"
            :filter-option="filterOption"
            :getPopupContainer="getsPopupContainer"
            :value="r_channel_id"
            allowClear
          >
            <a-select-option
              v-for="(item, index) in bookList"
              :key="index"
              :value="item.key"
            >
              {{ item.label }}
            </a-select-option>
          </a-select>
        </div>

        <div class="screen-box">
          <div class="screen-label">公众号</div>
          <gzhSearchMoreSelect
            @openGzhSelect="handleChangeA"
          ></gzhSearchMoreSelect>
        </div>
        <!-- 标签名称 -->
        <div class="screen-box">
          <div class="screen-label">标签名称</div>
          <a-select
            show-search
            style="min-width: 200px"
            placeholder="请选择标签名称"
            allowClear
            :options="selectOptions"
            v-model="r_tag_id"
          >
          </a-select>
        </div>
        <!--  -->

        <a-button
          class="screen-box"
          @click="searchButton('button')"
          :loading="search_button_loading"
          type="primary"
          icon="search"
          >搜索</a-button
        >
      </div>
    </div>

    <div style="background-color: #fff; padding: 20px 0 30px 20px">
      <!-- <div style="text-align: right;">
			<a-button @click="clickHandle(5)" class="screen-box" type="primary">批量新建标签</a-button>
		</div> -->
      <!-- 表头 -->
      <div class="table-th" :style="{ width: table_scroll_width + 'px' }">
        <div class="table-th-cell" :style="{ width: 50 + 'px' }">
          <a-checkbox
            :indeterminate="indeterminate"
            :checked="checkAll"
            @change="onCheckAllChange"
          ></a-checkbox>
        </div>
        <div v-for="(item, index) in rableTitle" :key="index">
          <div class="table-th-cell" :style="{ width: item.width + 'px' }">
            {{ item.title }}
          </div>
        </div>
      </div>

      <!-- 表格内容 -->
      <div
        v-for="(item, index) in tableShowData"
        :key="index"
        class="table-td"
        :style="{ width: table_scroll_width + 'px' }"
      >
        <!-- 选择 -->
        <div class="table-td-cell" :style="{ width: 50 + 'px' }">
          <a-checkbox
            :checked="item.checked"
            @change="onChangeCheckbox($event, index)"
          ></a-checkbox>
        </div>
        <template v-for="(z_tem, z_ndex) in rableTitle">
          <div
            v-if="
              z_tem.type != 'cz' &&
              z_tem.type != 'tag_name_list' &&
              z_tem.type != 'admin_user'
            "
            class="table-td-cell"
            :style="{ width: rableTitle[z_ndex].width + 'px' }"
          >
            {{ item[z_tem.type] }}
          </div>

          <div
            v-else-if="z_tem.type == 'cz'"
            class="table-td-cell"
            :style="{ width: rableTitle[z_ndex].width + 'px' }"
            style="display: flex"
          >
            <div @click="wxTdCz(1, item)" class="cz-cell">标签详情</div>
            <div @click="wxTdCz(2, item)" class="cz-cell">同步微信标签</div>
          </div>
          <div
            v-else-if="z_tem.type == 'tag_name_list'"
            class="table-td-cell"
            :style="{ width: rableTitle[z_ndex].width + 'px' }"
            style="display: flex; flex-wrap: wrap"
          ></div>
          <div
            v-else-if="z_tem.type == 'admin_user'"
            class="table-td-cell"
            :style="{ width: rableTitle[z_ndex].width + 'px' }"
            style="display: flex; padding-right: 4px"
          >
            <div class="div_text_name">
              {{ item.admin_user | formatAdminUser }}
            </div>
          </div>
        </template>
      </div>

      <!-- 表格内容为空时显示 -->
      <!-- <tableNull :tableShowData="tableShowData" :table_null_width="table_null_width"></tableNull> -->
      <div
        v-show="tableShowData.length === 0"
        style="text-align: center; margin: 80px 0 50px"
        :style="{ width: table_null_width + 'px' }"
      >
        <a-icon style="font-size: 70px; color: #999" type="file-search" />
        <div style="color: #999; font-size: 16px; margin-top: 20px">
          内容为空
        </div>
      </div>
      <div
        style="
          position: fixed;
          right: 0;
          bottom: 0;
          z-index: 6;
          background-color: #f0f2f5;
          height: calc(100vh - 65px);
          width: 30px;
        "
      ></div>
      <div
        style="
          position: fixed;
          left: 0;
          bottom: 0;
          z-index: 6;
          background-color: #f0f2f5;
          height: calc(100vh - 65px);
          width: 30px;
        "
      ></div>

      <!-- 分页 -->
      <pagingCompont
        :table_scroll_width="table_scroll_width"
        :table_null_width="table_null_width"
        :r_page="r_page"
        :r_limit="r_limit"
        :table_total="table_total"
        @pagination-Change="paginationChange"
        @change-size-limit="changeSizeLimit"
      ></pagingCompont>
    </div>

    <!-- 标签详情抽屉 visible_tag -->
    <a-drawer
      title="标签详情"
      width="700px"
      placement="right"
      :closable="false"
      :visible="visible_tag"
      @close="drawerClose"
    >
      <div style="height: 100%; position: relative">
        <div style="display: flex; align-items: center; margin-bottom: 10px">
          <a-button
            class="screen-box"
            style="margin-bottom: 0"
            @click="addShowModal()"
            type="primary"
            icon="plus"
            >新增标签</a-button
          >
          <a-button type="link" icon="sync" @click="wxTdCz(2, current_item)">
            同步微信标签
          </a-button>
        </div>

        <div
          style="
            display: flex;
            align-items: center;
            justify-content: center;
            height: 200px;
          "
          v-if="list_loading"
        >
          <a-spin />
        </div>
        <!-- 表头 -->
        <div
          v-if="!list_loading"
          class="table-th"
          :style="{ width: tagTable_width + 'px' }"
        >
          <div v-for="(item, index) in tagTable" :key="index">
            <div class="table-th-cell" :style="{ width: item.width + 'px' }">
              {{ item.title }}
            </div>
          </div>
        </div>
        <div v-if="!list_loading">
          <div
            v-for="(item, index) in tagData"
            :key="item.id"
            class="table-td"
            :style="{ width: tagTable_width + 'px' }"
          >
            <template v-for="(z_tem, z_ndex) in tagTable">
              <div
                v-if="
                  z_tem.type != 'type' &&
                  z_tem.type != 'status' &&
                  z_tem.type != 'cz'
                "
                class="table-td-cell"
                :style="{ width: tagTable[z_ndex].width + 'px' }"
              >
                {{ item[z_tem.type] }}
              </div>
              <div
                v-else-if="z_tem.type == 'type'"
                class="table-td-cell"
                :style="{ width: tagTable[z_ndex].width + 'px' }"
              >
                {{ item[z_tem.type] | msgTypeFilters }}
              </div>
              <div
                v-else-if="z_tem.type == 'status'"
                class="table-td-cell"
                :style="{ width: tagTable[z_ndex].width + 'px' }"
              >
                <a-switch
                  :checked="item.status_switch"
                  checked-children="开启"
                  un-checked-children="关闭"
                  @change="onStatusChange($event, item)"
                />
              </div>
              <div
                v-else-if="z_tem.type == 'cz'"
                class="table-td-cell"
                :style="{ width: tagTable[z_ndex].width + 'px' }"
                style="display: flex; font-size: 12px"
              >
                <div
                  @click="drawerTdCz(3, item)"
                  class="cz-cell"
                  style="color: red"
                >
                  删除
                </div>
              </div>
            </template>
          </div>
        </div>

        <div
          v-show="tagData.length == 0 && !list_loading"
          style="text-align: center; text-align: center; padding: 80px 0 50px"
          :style="{ width: tagTable_width + 'px' }"
        >
          <a-icon style="font-size: 70px; color: #999" type="file-search" />
          <div style="color: #999; font-size: 16px; margin-top: 20px">
            内容为空
          </div>
        </div>

        <pagingCompont
          :table_scroll_width="tagTable_width"
          :table_null_width="tagTable_width"
          :r_page="tag_page"
          :r_limit="tag_limit"
          :table_total="tag_total"
          @pagination-Change="paginationTag"
          @change-size-limit="paginationTag1"
        ></pagingCompont>

        <div
          style="
            position: absolute;
            left: 50%;
            top: 50%;
            transform: translate(-50%, -50%);
            z-index: 9;
          "
          v-show="drawer_search_loading"
        >
          <a-spin size="large" />
        </div>
      </div>
    </a-drawer>

    <a-modal
      :title="`新增标签`"
      width="800px"
      :visible="tag_modal_visible"
      :confirm-loading="tag_modal_loading"
      @ok="tagHandleOk"
      @cancel="tagHandleCancel"
    >
      <div>
        <div class="form_div">
          <div class="form-cell-box">
            <div class="class-title">名称</div>
            <a-input
              v-model="tag_list_params.name"
              placeholder="请输入标签名称"
              allowClear
            />
          </div>
          <div class="form-cell-box">
            <div class="class-title">类型</div>
            <a-select
              :options="GZH_LABEL_TYPE_LIST"
              style="width: 160px"
              v-model="tag_list_params.tag_type"
              placeholder="请选择标签类型"
              allowClear
            />
          </div>
          <div class="form-cell-box">
            <a-button
              type="primary"
              style="margin-left: 6px"
              @click="searchClick()"
              >搜索</a-button
            >
          </div>
        </div>
        <a-button type="primary" @click="jump()">新建标签</a-button>

        <!--  :row-selection="rowSelection"  -->
        <a-table
          :loading="r_loading"
          :columns="columns"
          :data-source="local_tag_list"
          :row-selection="{
            selectedRowKeys: selectedRowKeys,
            onChange: onSelectChange,
          }"
          :pagination="{
            defaultPageSize: 5,
            pageSize: 5,
            pageSizeOptions: ['3', '5', '8', '10'],
            total: r_total,
          }"
          @change="tagListChange"
        >
          <a slot="tag_type" slot-scope="tag_type">{{
            GZH_LABEL_TYPE_MAP[tag_type]
          }}</a>
        </a-table>
      </div>
    </a-modal>

    <!-- 加载中 -->
    <div class="loading-box" v-if="search_button_loading">
      <a-spin size="large" />
    </div>
  </div>
</template>

<script>
import locale from "ant-design-vue/es/date-picker/locale/zh_CN";
import moment from "moment";
import "moment/locale/zh-cn";
import moreSelect from "@/components/selectCompont/moreSelect.vue";
import gzhSearchMoreSelect from "@/components/selectCompont/searchSelect.vue";
import {
  gzhTagList,
  wxMaterialTag,
  gzhFansAddTag,
  gzhFansSyncTag,
  wxMaterialSelect,
  materialChannelSelect,
  gzhTagTable,
  gzhTagDel,
  getLocalGzhTagList,
  tagSyncToGzh,
  getSelectTagList,
} from "@/request/api";
import { GZH_LABEL_TYPE_LIST, GZH_LABEL_TYPE_MAP } from "./const.js";
export default {
  name: "gzhTag_",
  components: {
    moreSelect,
    gzhSearchMoreSelect,
  },
  data() {
    this.dateFormat = "YYYY-MM-DD";
    return {
      selectedRowKeys: [],
      GZH_LABEL_TYPE_MAP,
      columns: [
        {
          title: "标签ID",
          dataIndex: "id",
          key: "id",
        },
        {
          title: "标签名称",
          dataIndex: "name",
          key: "name",
        },
        {
          title: "标签类型",
          dataIndex: "tag_type",
          key: "tag_type",
          scopedSlots: { customRender: "tag_type" },
        },
        {
          title: "标签描述",
          dataIndex: "remark",
          key: "remark",
        },
      ],
      list_loading: false,
      GZH_LABEL_TYPE_LIST,
      locale,
      moment,
      startTime: "2022-06-12",
      endTime: "2022-06-23",

      // 表格部分内容
      // 表格的表头，规定宽度和要用的其他信息
      rableTitle: [
        { title: "公众号ID", width: 120, type: "id" },
        { title: "公众号名称", width: 200, type: "gzh_name" },
        { title: "渠道", width: 150, type: "channel_name" },
        { title: "标签数量", width: 90, type: "tag_count" },
        { title: "操作", width: 130, type: "cz" },
        { title: "管理员", width: 150, type: "admin_user" },
      ],
      tableShowData: [],
      table_scroll_width: 1000,
      table_null_width: 1000,

      search_button_loading: false,

      r_page: 1, // 页数
      r_limit: 50, // 每页多少条
      table_total: 0, // 表格内容总数

      r_start_time: null, // 开始时间
      r_end_time: null, // 结束时间
      r_channel_id: undefined, // 渠道
      r_gzh_id: undefined, // 公众号

      start_sub_time: null, // 关注起始时间
      end_sub_time: null, // 关注结束时间
      r_sex: undefined, // 性别
      r_subscribe_scene: undefined, // 粉丝来源/关注渠道
      r_province: undefined, // 省份
      r_nickname: null, // 昵称

      gzhSelect: [], // 公众号下拉

      searchSelect: {
        user: {},
        channel: {},
      }, // 渠道，公众号 下拉框数据

      sendTagData: [], // 标签

      provinceData: [], // 省份选择

      // 为用户添加标签
      tag_modal_visible: false,
      tag_modal_loading: false,
      refresh_tag_loading: false,
      sync_tag_loading: false,

      tag_gzh_name: "", // 当前选择的公众号名字

      add_tag_visible: false,
      add_tag_loading: false,
      add_tag_name: "",

      // 多选
      indeterminate: false,
      checkAll: false,
      selectedData: [], // 选中的数据

      tag_handle_type: 1, // 打tag的类型，1是打标签，2是一键标签，3是删除标签

      bookList: [], // 渠道下拉
      gzhSelect: [], // 公众号下拉

      visible_tag: false, // 标签详情-侧边栏
      tagTable: [
        { title: "标签ID", width: 90, type: "tag_id", text_right: false },
        { title: "标签名称", width: 170, type: "tag_name", text_right: false },
        { title: "标签数", width: 150, type: "tag_count", text_right: false },
        // {title:"标签条件", width:120, type:"type", text_right: true, },
        // {title:"系统自动标签", width:100, type:"status", text_right: true, },
        { title: "操作", width: 180, type: "cz", text_right: false },
      ],
      log_gzh_id: "",
      tagTable_width: 1000, // 表格宽度
      tagData: [],
      tag_page: 1,
      tag_limit: 20,
      tag_total: 0,
      drawer_search_loading: false,

      current_item: {},
      local_tag_list: [],
      tag_list_params: {
        tag_type: undefined,
        name: undefined,
        limit: 5,
        page: 1,
      },
      r_total: 0,
      r_loading: false,
      selectOptions: [],
      r_tag_name: undefined,
      r_tag_id: undefined,
    };
  },
  computed: {
    calcTagName() {
      if (this.selectOptions.length > 0) {
        const item = this.selectOptions.find(
          (item) => item.value === this.r_tag_id
        );

        return item ? item.label : "";
      }
      if (this.r_tag_name && this.r_tag_id) {
        return this.r_tag_name;
      }
      return undefined;
    },
  },
  async mounted() {
    let that = this;
    that.search_button_loading = true;

    // 获取当前日期
    that.endTime = this.$getThisDay();
    that.startTime = this.$getThisDay();

    // 获取表格信息
    let table_info = this.$getTableInfo(that.rableTitle);
    that.body_width = table_info.body_width;
    that.table_scroll_width = table_info.table_width - 30;
    that.table_null_width = table_info.null_width - 30;

    let fff = 0;
    that.tagTable.forEach((res) => {
      fff = fff + res.width;
    });
    that.tagTable_width = fff;

    materialChannelSelect().then((res) => {
      if (res.data.code == 0 || res.data.code == 200 || res.data.code == 8011) {
        that.selectData = res.data.data;
        let c_data = res.data.data.channel;
        let show_data = [];
        for (let key in c_data) {
          let ooo = {
            key,
            label: c_data[key],
            status: false,
          };
          show_data.push(ooo);
        }
        that.bookList = show_data;
      } else {
        if (res.data.code == 401) {
          // 未登录
          localStorage.removeItem("access_token");
          that.$router.replace({ name: "login", params: { type: "not_log" } });
        } else {
          that.$message.error(`错误：${res.data.msg}`);
        }
      }
    });
    if (this.$route.query && this.$route.query.tag_name) {
      this.r_tag_name = this.$route.query.tag_name;
      this.r_tag_id = this.$route.query.tag_id;
    }
    await this.getSelectList();
    this.searchButton();
  },
  methods: {
    async getSelectList() {
      try {
        const result = await getSelectTagList({});
        if (result.data.data.list) {
          const temp = [];
          const _obj = result.data.data.list;
          for (const key in _obj) {
            temp.push({
              value: key,
              label: _obj[key],
            });
          }
          this.selectOptions = temp;
        }
      } catch (error) {}
    },
    showErrorList(list) {
      const text = list.join(",");
      this.$confirm({
        content: text,
        onOk() {},
        onCancel() {},
      });
    },
    searchClick() {
      this.tag_list_params = {
        ...this.tag_list_params,
        page: 1,
      };
      this.getGzhTagList();
    },
    jump() {
      window.open(`${window.location.origin}/vue3/#/localTagList`, "_blank");
    },
    tagListChange(pagination) {
      const { current, pageSize } = pagination;
      this.tag_list_params = {
        ...this.tag_list_params,
        limit: pageSize,
        page: current,
      };
      this.getGzhTagList();
    },

    async getGzhTagList() {
      try {
        this.r_loading = true;
        this.selectedRowKeys = [];
        const result = await getLocalGzhTagList({
          ...this.tag_list_params,
        });
        if (result.data.code === 0) {
          this.local_tag_list = result.data.data.data;
          this.r_total = result.data.data.total;
        }
      } catch (error) {
        this.r_loading = false;
      } finally {
        this.r_loading = false;
      }
    },
    onSelectChange(selectedRowKeys, item) {
      this.selectedRowKeys = selectedRowKeys;
    },
    // 给ant design的select选择器重新设置定位
    getsPopupContainer(triggerNode) {
      return triggerNode.parentNode || document.body;
    },
    // filterOption1(input, option){
    //   console.log(input)
    //   console.log(option)
    // },
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      );
    },
    // 日期选择
    onChangeDate(date, dateString) {
      this.startTime = dateString[0];
      this.endTime = dateString[1];
    },
    onChangeDateC(value, dateString) {
      this.start_sub_time = dateString[0] || undefined;
      this.end_sub_time = dateString[1] || undefined;
    },
    onDateC_ok(value) {},

    // 公众号
    handleChangeA(value) {
      this.r_gzh_id = value;
      for (let key in this.gzhSelect) {
        if (key == value) {
          // 获取公众号名字
          this.tag_gzh_name = this.gzhSelect[key];
        }
      }
      this.getGzhTag();
    },
    getGzhTag() {
      let that = this;
      this.refresh_tag_loading = true;
      wxMaterialTag({
        page: this.tag_page,
        limit: this.tag_limit,
        gzh_id: this.r_gzh_id,
      }).then((res) => {
        that.refresh_tag_loading = false;
        if (
          res.data.code == 0 ||
          res.data.code == 200 ||
          res.data.code == 8011
        ) {
          let data = res.data.data.data;
          data.forEach((res) => {
            res.select_status = false;
          });
          that.sendTagData = res.data.data.data;
        } else {
          if (res.data.code == 401) {
            // 未登录
            localStorage.removeItem("access_token");
            that.$router.replace({
              name: "login",
              params: { type: "not_log" },
            });
          } else {
            that.$message.error(`错误：${res.data.msg}`);
          }
        }
      });
    },

    // 书城
    handleChangeB(e) {
      this.r_channel_id = e;
      // this.search_button_loading = true
      this.getGzhSelect(e);
    },
    // 根据渠道获取公众号
    getGzhSelect(e) {
      let that = this;
      wxMaterialSelect({
        channel_id: e,
      }).then((res) => {
        that.search_button_loading = false;

        if (res.data.code == 401) {
          // 未登录
          localStorage.removeItem("access_token");
          that.$router.replace({ name: "login", params: { type: "not_log" } });
          return;
        }
        that.gzhSelect = res.data.data.list;
      });
    },

    // 搜索
    searchButton(type) {
      let that = this;
      that.search_button_loading = true;

      if (type == "button") {
        that.r_page = 1;
      }
      if (type == "button" || type == "tag") {
        // 每次点击搜索按钮就清空选中状态
        that.selectedData = [];
        that.checkAll = false;
        that.indeterminate = false;
      }

      let r_data = {
        page: that.r_page,
        limit: that.r_limit,
        gzh_id: that.r_gzh_id, // 公众号

        channel_id: that.r_channel_id, // 书城/渠道
        tag_name: that.calcTagName,
      };

      gzhTagList(r_data).then((res) => {
        that.search_button_loading = false;
        if (
          res.data.code == 0 ||
          res.data.code == 200 ||
          res.data.code == 8011
        ) {
          // that.$message.success('搜索成功');
          that.table_total = res.data.data.total;
          let data = res.data.data.data;
          data.forEach((res) => {
            res.checked = false;
          });

          if (that.selectedData.length > 0) {
            let ccc = true;
            let iii = 0; // 用于判断是否全选
            data.forEach((res) => {
              that.selectedData.forEach((res_r) => {
                if (res.id === res_r.id) {
                  res.checked = true;
                  ccc = false;
                  iii = iii + 1;
                }
              });
            });
            if (iii === that.r_limit) {
              // 全选
              that.indeterminate = false;
              that.checkAll = true;
            } else {
              if (ccc) {
                that.checkAll = false;
                that.indeterminate = false;
              } else {
                that.checkAll = false;
                that.indeterminate = true;
              }
            }
          } else {
            that.checkAll = false;
            that.indeterminate = false;
          }

          that.tableShowData = res.data.data.data;
        } else {
          if (res.data.code == 401) {
            // 未登录
            localStorage.removeItem("access_token");
            that.$router.replace({
              name: "login",
              params: { type: "not_log" },
            });
          } else {
            that.$message.error(`错误：${res.data.msg}`);
          }
        }
      });
    },
    // 分页
    paginationChange(e) {
      this.r_page = e;
      this.searchButton();
    },
    changeSizeLimit(e) {
      this.r_limit = e;
      this.searchButton("button");
    },

    // 表格内的操作
    wxTdCz(e, item) {
      this.current_item = JSON.parse(JSON.stringify(item));
      let that = this;
      if (e == 1) {
        // 标签详情
        this.getTagTable(item.id, "显示", item);
      } else if (e == 2) {
        // 同步微信标签
        that.search_button_loading = true;
        gzhFansSyncTag({
          gzh_id: item.id,
        }).then((res) => {
          that.search_button_loading = false;
          if (
            res.data.code == 0 ||
            res.data.code == 200 ||
            res.data.code == 8011
          ) {
            that.$message.success(res.data.msg);
          } else {
            // 这里不能加401的判断，因为返回来的报错就是401，但是并不是登录过期的401
            that.$message.error(`错误：${res.data.msg}`);
          }
        });
      }
    },
    getTagTable(id, type, item) {
      let that = this;
      that.search_button_loading = true;
      if (item) {
        this.tag_gzh_name = item.gzh_name;
        this.log_gzh_id = item.id;
      }
      gzhTagTable({
        gzh_id: id,
      }).then((res) => {
        that.search_button_loading = false;
        if (
          res.data.code == 0 ||
          res.data.code == 200 ||
          res.data.code == 8011
        ) {
          that.tagData = res.data.data.data;
          that.tag_total = res.data.data.total;
          if (type == "显示") {
            that.visible_tag = true;
          }
        } else {
          if (res.data.code == 401) {
            // 未登录
            localStorage.removeItem("access_token");
            that.$router.replace({
              name: "login",
              params: { type: "not_log" },
            });
          } else {
            that.$message.error(`错误：${res.data.msg}`);
          }
        }
      });
    },

    // 操作按钮
    clickHandle(e) {
      this.tag_handle_type = e;

      if (e == 5) {
        // 批量新建
      }
    },

    // 侧边栏里的操作
    drawerTdCz(e, item) {
      let that = this;
      if (e == 3) {
        // 删除
        this.$confirm({
          title: "确定要删除吗?",
          content: `标签名称：${item.tag_name}`,
          okText: "删除",
          okType: "danger",
          cancelText: "取消",
          onOk() {
            gzhTagDel({
              // gzh_id: that.r_gzh_id,
              id: item.tag_id,
            }).then((res) => {
              if (res.data.code == 0) {
                that.$message.success("删除成功");
                that.getTagTable(that.log_gzh_id);
                that.searchButton();
              } else {
                if (res.data.code == 401) {
                  // 未登录
                  localStorage.removeItem("access_token");
                  that.$router.replace({
                    name: "login",
                    params: { type: "not_log" },
                  });
                } else {
                  that.$message.error(`错误：${res.data.msg}`);
                }
              }
            });
          },
          onCancel() {},
        });
      }
    },

    // 为用户添加标签
    tagHandleOk() {
      let that = this;
      that.tag_modal_loading = true;
      const names = [];
      for (let index = 0; index < this.selectedRowKeys.length; index++) {
        const element = this.selectedRowKeys[index];
        const item = this.local_tag_list[element];
        names.push(item.name);
      }
      gzhFansAddTag({
        gzh_id: that.log_gzh_id,
        name: names,
      })
        .then((res) => {
          that.tag_modal_loading = false;
          // that.showErrorList([
          //   `A公众号创建失败失败原因：。。。`,
          //   `B公众号创建失败，失败原因xxxxx`
          // ]);
          if (res.data.data.err_list && res.data.data.err_list.length > 0) {
            that.showErrorList(res.data.data.err_list);
          } else if (
            res.data.code == 0 ||
            res.data.code == 200 ||
            res.data.code == 8011
          ) {
            that.tagHandleCancel();
            that.$message.success("添加成功");
            that.getTagTable(that.log_gzh_id);
            that.searchButton();
          } else {
            that.$message.error(`错误：${res.data.msg}`);
          }
        })
        .catch(() => {
          that.tag_modal_loading = false;
        });
    },
    tagHandleCancel() {
      this.tag_modal_visible = false;
      this.tag_modal_loading = false;
      this.add_tag_name = "";
      // this.sendTagData.forEach(res=>{
      // 	res.select_status = false
      // })
    },
    // 添加更多标签
    addMoreTag() {},
    // 选择标签
    selectTagClick(item) {
      item.select_status = !item.select_status;
    },
    // 标签弹窗操作按钮
    tagModalHandle(e) {
      let that = this;
      if (e == 1) {
        // 新增标签
        this.add_tag_visible = true;
      } else if (e == 2) {
        // 同步微信标签
        this.sync_tag_loading = true;
        gzhFansSyncTag({
          gzh_id: this.r_gzh_id,
        }).then((res) => {
          this.sync_tag_loading = false;
          if (
            res.data.code == 0 ||
            res.data.code == 200 ||
            res.data.code == 8011
          ) {
            that.$message.success(res.data.msg);
          } else {
            // 这里不能加401的判断，因为返回来的报错就是401，但是并不是登录过期的401
            that.$message.error(`错误：${res.data.msg}`);
          }
        });
      } else if (e == 3) {
        // 刷新标签列表
        this.getGzhTag();
      }
    },

    addTagOk() {
      let that = this;
      if (!this.add_tag_name) {
        this.$message.warning("请输入标签名称");
      } else {
        this.add_tag_loading = true;
        gzhFansAddTag({
          name: this.add_tag_name,
          gzh_id: this.r_gzh_id,
        }).then((res) => {
          this.add_tag_loading = false;
          if (res.data.code == 0 || res.data.code == 200) {
            this.getTagTable();
            that.addTagCancel();
            that.getGzhTag();
          } else {
            that.$message.error(`错误：${res.data.msg}`);
          }
        });
      }
    },
    addTagCancel() {
      this.add_tag_visible = false;
      this.add_tag_loading = false;
    },

    // 多选测试
    onChangeCheckbox(checkedList, index) {
      let that = this;
      if (that.tableShowData[index].checked) {
        // 为选中状态，然后要改为未选中状态
        that.tableShowData[index].checked = false;

        let iii;

        that.selectedData.forEach((res, index_z) => {
          if (res.id == that.tableShowData[index].id) {
            iii = index_z;
          }
        });
        that.selectedData.splice(iii, 1);
      } else {
        // 未选中状态改为选中状态
        that.tableShowData[index].checked = true;
        if (that.selectedData.length === 0) {
          that.selectedData.push(that.tableShowData[index]);
        } else {
          // 判断有没有重复的内容，如果里面已经有重复的内容了，就不用再传了
          let ddd = true;
          for (let i = 0; i < that.selectedData.length; i++) {
            if (that.selectedData[i].id === that.tableShowData[index].id) {
              ddd = false;
              break;
            }
          }
          if (ddd) {
            that.selectedData.push(that.tableShowData[index]);
          }
        }
      }
      let ccc = true;
      let iii = false;
      let nnn = that.selectedData.length || 0;
      that.tableShowData.forEach((res) => {
        if (res.checked) {
          iii = true;
          // nnn = nnn + 1
        }
        if (!res.checked) {
          ccc = false;
        }
      });
      if (ccc) {
        that.indeterminate = false;
      } else {
        that.indeterminate = iii;
      }
      that.checkAll = ccc;
      that.selected_number = nnn;
    },
    // 全选
    onCheckAllChange(e) {
      let that = this;
      if (that.checkAll) {
        that.tableShowData.forEach((res) => {
          res.checked = false;
        });
        that.checkAll = false;
        // that.selected_number = 0

        that.selectedData = []; // 取消全选的时候，全部清除
      } else {
        that.tableShowData.forEach((res) => {
          res.checked = true;
          // 有重复的就不要传了
          let ddd = true;
          that.selectedData.forEach((res_r) => {
            if (res_r.id === res.id) {
              ddd = false;
            }
          });

          if (ddd) {
            that.selectedData.push(res);
          }
        });
        // that.selected_number = that.tableShowData.length
        that.indeterminate = false;
        that.checkAll = true;
      }
    },

    drawerClose() {
      this.visible_tag = false;
    },
    async getTagListFn() {
      try {
        this.list_loading=true
        const result = await gzhTagTable({
          gzh_id: this.log_gzh_id,
          limit: this.tag_limit,
          page: this.tag_page,
        });
        if (
          result.data.code == 0 ||
          result.data.code == 200 ||
          result.data.code == 8011
        ) {
          this.tagData = result.data.data.data;
          this.tag_total = result.data.data.total;
          return
        }
        if (result.data.code == 401) {
          // 未登录
          localStorage.removeItem("access_token");
          this.$router.replace({
            name: "login",
            params: { type: "not_log" },
          });
          return
        } else if(result.data.msg){
          this.$message.error(`错误：${result.data.msg}`);
        }
      } catch (error) {
        this.list_loading = false;
      } finally {
        this.list_loading = false;
      }
    },
    paginationTag1(e) {
      this.tag_limit = e;
      this.getTagListFn();
    },
    paginationTag(e) {
      this.tag_page = e;
      this.getTagListFn();
    },
    addShowModal() {
      this.tag_modal_visible = true;
      this.getGzhTagList();
    },
  },
  filters: {
    logData_status(value) {
      let vvv = "";
      if (value == 0) {
        vvv = "待发送";
      } else if (value == 1) {
        vvv = "成功";
      } else if (value == 2) {
        vvv = "失败";
      }
      return vvv;
    },
    msgTypeFilters(value) {
      let vvv = "";
      if (value == 1) {
        vvv = "文本";
      } else if (value == 2) {
        vvv = "图片消息";
      } else if (value == 3) {
        vvv = "单条图文消息";
      } else if (value == 4) {
        vvv = "多条图文消息";
      }
      return vvv;
    },
    formatAdminUser(val) {
      const userList = [];
      if (Object.keys(val).length > 0) {
        for (const key in val) {
          userList.push(val[key]);
        }
        return userList.join(", ");
      }
      return "";
    },
  },
};
</script>

<style scoped>
.screen-box {
  margin-bottom: 5px;
}
/* .table-td-cell {
	font-size: 14px;
} */
/* 表格内的操作按钮 */
.cz-cell {
  color: #62a8ea;
  cursor: pointer;
  margin-right: 12px;
  /* margin-bottom: 5px; */
}
.cz-cell:hover {
  color: rgb(47, 136, 255);
}

.form-cell-box {
  /*  margin-bottom: 20px;*/
}

.msg-cell-title {
  margin-bottom: 10px;
}

.left-box {
  /* padding: 15px; */
  /* border: 1px solid #ccc; */
  position: sticky;
  top: 70px;
  width: 300px;
  background: #fff;
  padding: 23px;
}
.left-box-border {
  border: 2px solid #409eff;
}
.left-top-title {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  background-color: rgba(0, 0, 0, 0.7);
  color: #fff;
  padding: 5px 12px;
}
.left-cell-top {
  position: relative;
  cursor: pointer;
}
.left-cell-box {
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
  padding: 12px;
}
.left-cell-box-boder {
  border-bottom: 1px solid #e8e8e8;
}
.left-cell-img {
  width: 50px;
  height: 50px;
}
.left-cell-operation {
  display: none;
  position: absolute;
  bottom: 0;
  left: 0;
  z-index: 3;
  /* display: flex; */
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: 5px 7px;
  background-color: rgba(0, 0, 0, 0.7);
}
.left-cell-top:hover .left-cell-operation {
  display: flex;
}
.left-cell-box:hover .left-cell-operation {
  display: flex;
}
.left-cell-operation-icon {
  color: #fff;
  font-size: 16px;
}
.left-cell-add {
  text-align: center;
  font-size: 16px;
  padding: 15px 0 5px;
  cursor: pointer;
}

.cover-handle {
  display: none;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 9;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  /* display: flex; */
  align-items: center;
  justify-content: space-around;
}
.cover-box:hover .cover-handle {
  display: flex;
}

.type-3:hover .cover-handle {
  display: flex;
}

.td-tag-box {
  margin-right: 7px;
  margin-bottom: 3px;
}

/* 按钮 */
.handle-button {
  padding: 5px 10px;
  /* height: 24px; */
  box-sizing: border-box;
  border-radius: 2px;
  font-size: 13px;
  /* color: #40a9ff;
	border: 1px solid #40a9ff; */
  cursor: pointer;
  color: #1890ff;
  border: 1px solid #1890ff;

  margin-right: 20px;
}
.handle-button:hover {
  background-color: #1890ff;
  color: #fff;
}

.tag-modal-box {
  padding: 2px 9px;
  height: 24px;
  box-sizing: border-box;
  border-radius: 2px;
  font-size: 13px;
  cursor: pointer;

  margin-right: 20px;
  margin-bottom: 7px;
}
.tag-modal-box-true {
  color: #1890ff;
  border: 1px solid #1890ff;
  background-color: #e8efff;
}
.tag-modal-box-false {
  color: #333;
  border: 1px solid #f7f8fa;
  background-color: #f7f8fa;
}
.form_div {
  display: flex;
}
.class-title {
  width: 40px;
}
</style>
